export const integrationsRoutes = {
  internal: {
    getIntegrations: '/internal/integrations',
  },
};
